export function range(start = 0, end = 0) {
  return (new Array(end - start + 1)).fill(undefined).map((_, i) => i + start);
}

export function equals (array1, array2) {
  if (array1.length !== array2.length) return false;
  for (let i = 0; i<array1.length; i++) {
    if (array1[i] !== array2[i]) return false;
  }
  return true;
}

/**
 *
 * @param {Array} haystack
 * @param {Array}needle
 * @returns {boolean}
 */
export function contains (haystack, needle) {
  for (const index in needle) {
    if (haystack[index] !== needle[index]) return false;
  }
  return true;
}

export function hasIntersection (a, b) {
  for (const item of a) {
    if (b.indexOf(item) !== -1) return true;
  }
  return false;
}

export function hashGet (data, path, defaultValue = null) {
  if (path === null || path === '') return data ? data : defaultValue;
  const internalPath = path.split('.');
  if (internalPath.length === 0) {
    return defaultValue;
  }
  if (data[internalPath[0]] !== undefined) {
    return internalPath.length > 1 ? hashGet(data[internalPath[0]], internalPath.slice(1).join('.')): data[internalPath[0]];
  }
  return defaultValue;
}



// WEBPACK FOOTER //
// ./src/helpers/array.helper.js